import React, { useEffect, useState } from 'react';
import './ClientsTab.css';
import UniversalTable from '../UniversalTable/UniversalTable';
import { createPortal } from 'react-dom';
import WorkplacesInStaffTab from '../WorkplacesInStaffTab/WorkplacesInStaffTab';
import CreateClientModal from '../CreateClientModal/CreateClientModal';
const ClientsTab = ({
  dataList,
  handleContextMenu,
  selectedItems,
  activePopup,
  handleSelectedPopup,
  selectedItemId,
  updateTabData,
  selectedTab,
  onSelectItem,
  deleteError,
  handleTypeActionClear,
  menuTarget,
}) => {
  const [isCreateEmployeeMounted, setIsCreateEmployeeMounted] = useState(false);
  const [isCreateEmployeeVisible, setIsCreateEmployeeVisible] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);
  const columns = [
    { key: 'number', title: '№' },
    { key: 'name', title: 'Клиент' },
    { key: 'login', title: 'Логин' },
    { key: 'phone', title: 'Телефон' },
  ];

  // Управление анимацией при изменении activePopup
  useEffect(() => {
    if (activePopup === 'clients') {
      // Монтируем компонент
      setIsCreateEmployeeMounted(true);
      // Через 100мс включаем видимость для анимации
      const showTimer = setTimeout(() => setIsCreateEmployeeVisible(true), 100);
      return () => clearTimeout(showTimer);
    } else {
      // Сначала убираем видимость для анимации
      setIsCreateEmployeeVisible(false);
      // Через 300мс демонтируем компонент
      const hideTimer = setTimeout(() => {
        if (!isCreateEmployeeVisible) {
          setIsCreateEmployeeMounted(false);
        }
      }, 1000);
      return () => clearTimeout(hideTimer);
    }
  }, [activePopup, isCreateEmployeeVisible]);

  const handleRowClick = (rowId) => {
    if (expandedRow === rowId) {
      setExpandedRow(null);
      handleTypeActionClear();
    } else {
      setExpandedRow(rowId);
    }
  };
  const data = dataList.map((item, index) => ({
    ...item,
    name: `${item.last_name ?? ''} ${item.first_name ?? ''} ${item.patronymic ?? ''}`,
    children: (
      <>
        {item.workplace && item.workplace.length > 0 && (
          <WorkplacesInStaffTab
            dataList={JSON.parse(item.workplace)}
            handleContextMenu={handleContextMenu}
            selectedItems={selectedItems}
            selectedItemId={selectedItemId}
            expandedRow={expandedRow}
            onSelectItem={onSelectItem}
            updateDepartmentData={updateTabData}
            deleteError={deleteError}
          />
        )}
      </>
    ),
  }));
  return (
    <div className='staff-tab'>
      <UniversalTable
        data={data}
        columns={columns}
        handleContextMenu={handleContextMenu}
        selectedItems={selectedItems}
        onRowClick={handleRowClick}
        onSelectItem={onSelectItem}
        expandedRow={expandedRow}
      />

      {isCreateEmployeeMounted &&
        createPortal(
          <CreateClientModal
            updateTabData={updateTabData}
            selectedTab={selectedTab}
            isEmployeeFormOpen={isCreateEmployeeVisible}
            handleClose={() => {
              // Запускаем анимацию закрытия
              setIsCreateEmployeeVisible(false);
              // После анимации уведомляем родительский компонент
              handleSelectedPopup(false);
            }}
            selectedItemId={selectedItemId}
          />,
          document.body
        )}
    </div>
  );
};

export default ClientsTab;
